// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const vehicleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/vehicle/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
    }),

    deleteVehicleData: builder.mutation({
      query: () => ({
        url: "/api/v1/admin/vehicle/remove",
        method: "DELETE",
      }),
    }),

    updateVehicleTags: builder.mutation({
      query: ({ car_id, tags }) => ({
        url: "/api/v1/admin/vehicle/tags",
        method: "PATCH",
        body: { car_id, tags },
      }),
    }),
  }),
});

export const {
  useGetVehiclesQuery,
  useDeleteVehicleDataMutation,
  useUpdateVehicleTagsMutation,
} = vehicleApiSlice;
